import breakpoints from "@constants/breakpoints"

const Theme = {
  breakpoints,
}

export default Theme
